module.exports = __webpack_public_path__ + "media/images/logo/product-women-31ce3b76bc9bb58abb2dbe4520de2dd4.jpg";